/** @jsxImportSource @emotion/react */
import { Typography, Avatar, Row, Col } from "antd";
import React from "react";
import * as Styles from "./styles";

interface ProfileItemComponentProps {
  firstName: string;
  lastName: string;
  roleName: string;
  imageUrl?: string;
  inlineCollapsed: boolean;
}

const ProfileItemComponent: React.FC<ProfileItemComponentProps> = ({
  firstName,
  lastName,
  roleName,
  imageUrl,
  inlineCollapsed,
}: ProfileItemComponentProps) => {
  const memoAvatarName = React.useMemo(() => {
    const firstLastNameChar = lastName.charAt(0).toUpperCase() || "";
    const firstFirstNameChar = firstName.charAt(0).toUpperCase() || "";
    return `${firstFirstNameChar}${firstLastNameChar}`;
  }, [firstName, lastName]);

  return (
    <Row
      css={
        inlineCollapsed ? Styles.collapsedContainerStyle : Styles.containerStyle
      }
    >
      <Col>
        <Avatar src={imageUrl} size={48}>
          {memoAvatarName}
        </Avatar>
      </Col>
      {!inlineCollapsed && (
        <Col css={Styles.profileStyle}>
          <Typography.Text css={Styles.avaNameStyle}>
            <b>
              {firstName} {lastName}
            </b>
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">{roleName}</Typography.Text>
        </Col>
      )}
    </Row>
  );
};

export const ProfileItem = React.memo(ProfileItemComponent);
